export const TABS_ENUM = {
  PHOTO: 'photos',
  PROJECT: 'projects',
  LAYOUT: 'layouts',
  BACKGROUND: 'backgrounds',
  CLIPART: 'cliparts',
  OVERLAYER: 'overlayers',
};
